<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}">
						<h4 class="card-title">
							<i class="material-icons" (click)="back()" style="cursor:pointer">arrow_left</i>
							Accounting Data Attestation
						</h4>
					</div>
					<div class="card-body">

						<!-- Period / date picker -->
						<form [formGroup]="formGroup" *ngIf="formGroup">
							<div class="range-toolbar">
								<button type="button" [class.active]="formGroup.get('range_mode')?.value === 'period'" (click)="setRangeMode('period')">Period</button>
								<button type="button" (click)="setDatePreset('this_week')">This Week</button>
								<button type="button" (click)="setDatePreset('last_week')">Last Week</button>
								<button type="button" (click)="setDatePreset('this_month')">This Month</button>
								<button type="button" (click)="setDatePreset('last_month')">Last Month</button>
								<button type="button" [class.active]="formGroup.get('range_mode')?.value === 'date'" (click)="setRangeMode('date')">Custom</button>
							</div>

							<div class="row align-items-end" *ngIf="formGroup.get('range_mode')?.value === 'period'">
								<div class="col-md-4 col-12 mb-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>From Period</mat-label>
										<mat-select formControlName="from_period" (selectionChange)="updateToOptions($event.value)">
											<mat-option *ngFor="let p of from_period_options" [value]="p.periodno">
												{{ p.lastdate_in_period }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-4 col-12 mb-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>To Period</mat-label>
										<mat-select formControlName="to_period" (selectionChange)="updateFromOptions($event.value)">
											<mat-option *ngFor="let p of to_period_options" [value]="p.periodno">
												{{ p.lastdate_in_period }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-4 col-12 mb-2">
									<button type="button" mat-raised-button color="accent" (click)="run()" [disabled]="loading || !formGroup.valid">
										<mat-spinner diameter="18" *ngIf="loading" style="display:inline-block;margin-right:6px"></mat-spinner>
										Run Report
									</button>
								</div>
							</div>

							<div class="row align-items-end" *ngIf="formGroup.get('range_mode')?.value === 'date'">
								<div class="col-md-4 col-12 mb-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>From Date</mat-label>
										<input matInput [matDatepicker]="shieldFromDatePicker" formControlName="from_date">
										<mat-datepicker-toggle matSuffix [for]="shieldFromDatePicker"></mat-datepicker-toggle>
										<mat-datepicker #shieldFromDatePicker></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-4 col-12 mb-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>To Date</mat-label>
										<input matInput [matDatepicker]="shieldToDatePicker" formControlName="to_date">
										<mat-datepicker-toggle matSuffix [for]="shieldToDatePicker"></mat-datepicker-toggle>
										<mat-datepicker #shieldToDatePicker></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-4 col-12 mb-2">
									<button type="button" mat-raised-button color="accent" (click)="run()" [disabled]="loading || !formGroup.valid">
										<mat-spinner diameter="18" *ngIf="loading" style="display:inline-block;margin-right:6px"></mat-spinner>
										Run Report
									</button>
								</div>
							</div>
						</form>

						<ng-container *ngIf="report && summary">

							<!-- Export bar -->
							<div class="export-bar">
								<button type="button" class="btn btn-success btn-sm" (click)="exportXlsx()" [disabled]="exporting || loading" title="Export Excel">
									<i class="fa fa-file-excel-o"></i> Excel
								</button>
								&nbsp;
								<button type="button" class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting || loading" title="Export PDF">
									<i class="fa fa-file-pdf-o"></i> PDF
								</button>
								<mat-spinner diameter="18" *ngIf="exporting" style="display:inline-block;margin-left:8px;vertical-align:middle"></mat-spinner>
							</div>

							<!-- ============================================================
							     Accounting Data Attestation (A–X) — GL sourced.
							     Greyed rows are computed subtotals; white rows are the input fields.
							     ============================================================ -->
							<div class="attest-panel" *ngIf="attestation">
								<h3>Accounting Data Attestation</h3>

								<div class="attest-check attest-check-bad" *ngIf="!balanceOk">
									<mat-icon>warning</mat-icon>
									General Ledger is out of balance by
									<strong>{{ attestation.balance_check | currency }}</strong>
									(Total Assets − Liabilities − Capital − YTD Net Income). Review the GL before submitting to the bank.
								</div>
								<div class="attest-check attest-check-ok" *ngIf="balanceOk">
									<mat-icon>check_circle</mat-icon>
									Balanced — Total Assets = Liabilities + Capital + YTD Net Income.
								</div>

								<!-- Cannabis excise tax memo — not on the A–X form (excise ≠ income tax);
								     surfaced for the bank because it is central to a cannabis account. -->
								<div class="excise-memo" *ngIf="attestation.excise">
									<div class="excise-title">NYS Cannabis Excise Tax <span>(pass-through — collected &amp; remitted to NYS; not income tax)</span></div>
									<div class="excise-figs">
										<div class="fig"><span class="lbl">Accrued (fiscal YTD)</span><span class="val">{{ attestation.excise.accrued_ytd | currency }}</span></div>
										<div class="fig"><span class="lbl">Remitted to NYS (fiscal YTD)</span><span class="val">{{ attestation.excise.remitted_ytd | currency }}</span></div>
										<div class="fig owed"><span class="lbl">Owed to NYS (as of {{ attestation.asof_label }})</span><span class="val">{{ attestation.excise.owed | currency }}</span></div>
									</div>
								</div>

								<div class="attest-grid">
									<!-- Income Statement -->
									<div class="attest-col">
										<div class="attest-subhead">Income Statement <span>{{ attestation.is_range_label }}</span></div>
										<table class="attest-table">
											<tbody>
												<ng-container *ngFor="let ln of attestation.income_statement">
													<tr class="attest-row" [class.computed]="ln.computed" [class.expandable]="!ln.computed && ln.accounts.length"
														(click)="(!ln.computed && ln.accounts.length) ? toggleLine('is-'+ln.key) : null">
														<td class="letter"><span class="letter-chip">{{ ln.key }}</span></td>
														<td class="ln-label">
															{{ ln.label }}
															<mat-icon *ngIf="!ln.computed && ln.accounts.length" class="expand-caret">
																{{ expandedLine === 'is-'+ln.key ? 'expand_less' : 'expand_more' }}
															</mat-icon>
														</td>
														<td class="ln-amount">{{ ln.amount | currency }}</td>
														<td class="ln-copy">
															<mat-icon *ngIf="!ln.computed" class="copy-btn" matTooltip="Copy" (click)="$event.stopPropagation(); copyToClipboard(ln.amount)">content_copy</mat-icon>
														</td>
													</tr>
													<tr *ngIf="expandedLine === 'is-'+ln.key" class="attest-detail-row">
														<td></td>
														<td colspan="3">
															<table class="attest-detail">
																<tr *ngFor="let a of ln.accounts">
																	<td class="acct">{{ a.code }} — {{ a.name }}</td>
																	<td class="acct-amt">{{ a.amount | currency }}</td>
																</tr>
															</table>
														</td>
													</tr>
												</ng-container>
											</tbody>
										</table>
									</div>

									<!-- Balance Sheet -->
									<div class="attest-col">
										<div class="attest-subhead">Balance Sheet <span>As of {{ attestation.asof_label }}</span></div>
										<table class="attest-table">
											<tbody>
												<ng-container *ngFor="let ln of attestation.balance_sheet">
													<tr class="attest-row" [class.computed]="ln.computed" [class.expandable]="!ln.computed && ln.accounts.length"
														(click)="(!ln.computed && ln.accounts.length) ? toggleLine('bs-'+ln.key) : null">
														<td class="letter"><span class="letter-chip">{{ ln.key }}</span></td>
														<td class="ln-label">
															{{ ln.label }}
															<span *ngIf="ln.key === 'X'" class="ytd-tag">{{ attestation.ytd_label }}</span>
															<mat-icon *ngIf="!ln.computed && ln.accounts.length" class="expand-caret">
																{{ expandedLine === 'bs-'+ln.key ? 'expand_less' : 'expand_more' }}
															</mat-icon>
														</td>
														<td class="ln-amount">{{ ln.amount | currency }}</td>
														<td class="ln-copy">
															<mat-icon *ngIf="!ln.computed" class="copy-btn" matTooltip="Copy" (click)="$event.stopPropagation(); copyToClipboard(ln.amount)">content_copy</mat-icon>
														</td>
													</tr>
													<tr *ngIf="expandedLine === 'bs-'+ln.key" class="attest-detail-row">
														<td></td>
														<td colspan="3">
															<table class="attest-detail">
																<tr *ngFor="let a of ln.accounts">
																	<td class="acct">{{ a.code }} — {{ a.name }}</td>
																	<td class="acct-amt">{{ a.amount | currency }}</td>
																</tr>
															</table>
														</td>
													</tr>
												</ng-container>
											</tbody>
										</table>
									</div>
								</div>
							</div>

							<!-- Shield Upload Box (AR-split supporting view) -->
							<div class="shield-panel">
								<h3>Distribution &amp; Brand Payouts</h3>
								<div class="basis-note">Invoice-date basis. AR split.</div>

								<div class="shield-field">
									<div class="label">Gross Sales<span class="hint">Invoiced, excise included</span></div>
									<div style="display:flex;align-items:center">
										<span class="amount">{{ summary.shield_sales | currency }}</span>
										<mat-icon class="copy-btn" matTooltip="Copy" (click)="copyToClipboard(summary.shield_sales)">content_copy</mat-icon>
									</div>
								</div>

								<div class="shield-field">
									<div class="label">Less: Excise Tax<span class="hint">NYS pass-through — not MOOV revenue</span></div>
									<div style="display:flex;align-items:center">
										<span class="amount">{{ summary.shield_excise | currency }}</span>
										<mat-icon class="copy-btn" matTooltip="Copy" (click)="copyToClipboard(summary.shield_excise)">content_copy</mat-icon>
									</div>
								</div>

								<div class="shield-field">
									<div class="label">Net Sales</div>
									<div style="display:flex;align-items:center">
										<span class="amount">{{ summary.shield_net_sales | currency }}</span>
										<mat-icon class="copy-btn" matTooltip="Copy" (click)="copyToClipboard(summary.shield_net_sales)">content_copy</mat-icon>
									</div>
								</div>

								<div class="shield-field">
									<div class="label">Less: Brand Payouts<span class="hint">Cost of sales</span></div>
									<div style="display:flex;align-items:center">
										<span class="amount">{{ summary.shield_cogs | currency }}</span>
										<mat-icon class="copy-btn" matTooltip="Copy" (click)="copyToClipboard(summary.shield_cogs)">content_copy</mat-icon>
									</div>
								</div>

								<div class="shield-field gross-profit-field">
									<div class="label">Gross Profit<span class="hint">Distribution fee + processing</span></div>
									<div style="display:flex;align-items:center">
										<span class="amount">{{ summary.shield_gross_profit | currency }}</span>
										<mat-icon class="copy-btn" matTooltip="Copy" (click)="copyToClipboard(summary.shield_gross_profit)">content_copy</mat-icon>
									</div>
								</div>

								<div class="meta-row">
									<div class="meta-item">Invoices: <strong>{{ summary.invoice_count }}</strong></div>
									<div class="meta-item">Distribution Fee: <strong>{{ summary.moov_revenue | currency }}</strong></div>
									<div class="meta-item">Processing Fees: <strong>{{ summary.processing_fees | currency }}</strong></div>
									<div class="meta-item" [class.tie-bad]="!marginTies">
										Fee + Processing: <strong>{{ summary.moov_revenue + summary.processing_fees | currency }}</strong>
										<span *ngIf="marginTies"> — ties</span>
										<span *ngIf="!marginTies"> — off by {{ marginVariance | currency }}</span>
									</div>
								</div>
							</div>

							<!-- By Brand — click a brand to see its invoices -->
							<ng-container>
								<div class="table-responsive">
									<table class="table table-striped table-bordered table-sm">
										<thead>
											<tr>
												<th></th>
												<th>Brand / Supplier</th>
												<th class="text-right">Invoices</th>
												<th class="text-right">Gross Sales</th>
												<th class="text-right">Brand Payout</th>
												<th class="text-right">METRC Tax</th>
												<th class="text-right">Distribution Rev</th>
												<th class="text-right">Fees</th>
												<th class="text-right">Customer Paid</th>
												<th class="text-right">Brand Paid Out</th>
											</tr>
										</thead>
										<tbody>
											<ng-container *ngFor="let brand of byBrand">
												<tr [class.brand-row-expanded]="expandedBrand === brand.supplierno"
													style="cursor:pointer" (click)="toggleBrand(brand.supplierno)">
													<td>
														<mat-icon style="font-size:16px;vertical-align:middle">
															{{ expandedBrand === brand.supplierno ? 'expand_less' : 'expand_more' }}
														</mat-icon>
													</td>
													<td><strong>{{ brand.suppname || brand.supplierno }}</strong></td>
													<td class="text-right">{{ brand.invoice_count }}</td>
													<td class="text-right">{{ brand.gross_amount | currency }}</td>
													<td class="text-right">{{ brand.brand_amount | currency }}</td>
													<td class="text-right">{{ brand.metrc_amount | currency }}</td>
													<td class="text-right">{{ brand.moov_revenue | currency }}</td>
													<td class="text-right">{{ brand.processing_fees | currency }}</td>
													<td class="text-right">{{ brand.customer_paid | currency }}</td>
													<td class="text-right">{{ brand.brand_paid_out | currency }}</td>
												</tr>
												<!-- Expanded invoice sub-table -->
												<tr *ngIf="expandedBrand === brand.supplierno">
													<td colspan="10" style="padding:0 12px 12px 36px;background:#f5f8ff">
														<table class="invoice-sub-table">
															<thead>
																<tr>
																	<th>Date</th>
																	<th>Inv #</th>
																	<th>Customer</th>
																	<th class="text-right">Gross</th>
																	<th class="text-right">Brand</th>
																	<th class="text-right">METRC</th>
																	<th class="text-right">Dist.</th>
																	<th class="text-right">Fee</th>
																	<th class="text-right">Cust. Paid</th>
																	<th>Status</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let inv of brandInvoices(brand.supplierno)">
																	<td>{{ inv.trandate | date:'MMM d, y' }}</td>
																	<td>{{ inv.transno }}</td>
																	<td>{{ inv.custname }}</td>
																	<td class="text-right">{{ inv.gross_amount | currency }}</td>
																	<td class="text-right">{{ inv.brand_amount | currency }}</td>
																	<td class="text-right">{{ inv.metrc_amount | currency }}</td>
																	<td class="text-right">{{ inv.moov_revenue | currency }}</td>
																	<td class="text-right">{{ inv.processing_fee | currency }}</td>
																	<td class="text-right">{{ inv.customer_paid | currency }}</td>
																	<td>
																		<span [class]="'badge-' + invoiceStatus(inv).toLowerCase()">
																			{{ invoiceStatus(inv) }}
																		</span>
																	</td>
																</tr>
															</tbody>
														</table>
													</td>
												</tr>
											</ng-container>

											<!-- Totals row -->
											<tr style="font-weight:700;background:#e8f0fe">
												<td colspan="2">TOTALS</td>
												<td class="text-right">{{ summary.invoice_count }}</td>
												<td class="text-right">{{ summary.gross_sales | currency }}</td>
												<td class="text-right">{{ summary.brand_payout | currency }}</td>
												<td class="text-right">{{ summary.metrc_tax | currency }}</td>
												<td class="text-right">{{ summary.moov_revenue | currency }}</td>
												<td class="text-right">{{ summary.processing_fees | currency }}</td>
												<td class="text-right"></td>
												<td class="text-right"></td>
											</tr>
										</tbody>
									</table>
								</div>
							</ng-container>

							<!-- Hidden full-report source for XLSX / PDF export.
							     Uses Bootstrap table classes so the server print header
							     (bootstrap.min.css + .table-fixed styling) renders the same
							     polished look as the other GL report exports. -->
							<div class="shield-print-root" #print_table>

								<ng-container *ngIf="attestation">
									<h4 class="mt-2">Income Statement — {{ attestation.is_range_label }}</h4>
									<table class="table table-fixed table-striped table-sm table-bordered" style="width:70%">
										<tbody>
											<tr *ngFor="let ln of attestation.income_statement" [class.subhead]="ln.computed" [class.font-weight-bold]="ln.computed">
												<th class="text-left">{{ ln.key }} &nbsp; {{ ln.label }}</th>
												<td class="text-right">{{ ln.amount | currency }}</td>
											</tr>
										</tbody>
									</table>

									<h4 class="mt-4">Balance Sheet — As of {{ attestation.asof_label }}</h4>
									<table class="table table-fixed table-striped table-sm table-bordered" style="width:70%">
										<tbody>
											<tr *ngFor="let ln of attestation.balance_sheet" [class.subhead]="ln.computed" [class.font-weight-bold]="ln.computed">
												<th class="text-left">{{ ln.key }} &nbsp; {{ ln.label }}{{ ln.key === 'X' ? ' (' + attestation.ytd_label + ')' : '' }}</th>
												<td class="text-right">{{ ln.amount | currency }}</td>
											</tr>
										</tbody>
									</table>

									<table class="table table-fixed table-sm table-bordered" style="width:70%" *ngIf="attestation.excise">
										<tbody>
											<tr><th class="text-left">NYS Cannabis Excise — Remitted</th><td class="text-right">{{ attestation.excise.remitted_ytd | currency }}</td></tr>
											<tr><th class="text-left">NYS Cannabis Excise — Owed (as of {{ attestation.asof_label }})</th><td class="text-right">{{ attestation.excise.owed | currency }}</td></tr>
										</tbody>
									</table>
								</ng-container>
							</div>

						</ng-container>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
